export default __webpack_public_path__ + "static/media/right-hand.63af1198.gif";